import {Button, Col, Form, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import DataTable from 'react-data-table-component';
import {Link} from 'react-router-dom';
import AppRoute from "../../utils/AppRoute";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const AdminCourses = () => {

    const [currentRow, setCurrentRow] = useState();
	const [courseFilter, setCourseFilter] = useState(() => {
	        return localStorage.getItem("courseFilter") || "1";
	    });
    const [courseItems, setCourseItems] = useState([]);
	const [currentPage, setCurrentPage] = useState(null);

    const [pageSize, setPageSize] = useState(10000);

	useEffect(() => {
	    const savedPage = localStorage.getItem("adminCoursesPage");
	    if (savedPage !== null) {
			console.log("setCurrentPage("+parseInt(savedPage, 10)+")")

	        setCurrentPage(parseInt(savedPage, 10));
	    } else {
			console.log("setCurrentPage(0)")
	        setCurrentPage(0);
	    }
	}, []);
    useEffect(() => {

        ApiService.getCourses().then(courseData => {
            createCourseItem(courseData.courseDtos);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
	useEffect(() => {
	    localStorage.setItem("courseFilter", courseFilter);
	}, [courseFilter]);
		
    useEffect(() => {
        let pageParams = {
            pageSize: pageSize,
        };

        ApiService.getCourses(pageParams).then(courseData => {
            const currentDate = new Date().toISOString().split('T')[0];
            let filteredCourses = filterCourses(courseFilter, courseData.courseDtos, currentDate)
            createCourseItem(filteredCourses);
        })
    },[courseFilter, currentPage, pageSize]);

    const createCourseItem = async (courseDataList) => {
        let courseItemList = []

        for (let i = 0; i < courseDataList.length; i++) {
            let course = courseDataList[i];
            let currentPool = await ApiService.getPoolById(course.piscinaId)
            let currentLevel = await ApiService.getLevelById(course.levelCourseId)

            let courseItem = {
                id: course.id,
                title: course.title,
                place: (currentPool.place && currentPool.place.split(";")[0]),
                category: currentLevel.level,
                start: DateTimeUtils.formatCourseStartData(course.visibilityStart),
                to: DateTimeUtils.fromTimeMillisToDate(course.visibilityEnd)
            }

            courseItemList.push(courseItem);
        }
        setCourseItems(courseItemList);
    }

	const handlePageChange = (page) => {
	    const newPage = page - 1;
	    setCurrentPage(newPage);
	    localStorage.setItem("adminCoursesPage", newPage.toString());
		console.log("adminCoursesPage store ("+newPage.toString()+")")

	};

    const filterCourses = (userChoice, courseDtos, currentDate) => {
        switch (userChoice) {
            case "0":
                return courseDtos;
            case "3":
                return courseDtos.filter(item => item.visibilityStart > currentDate);
            case "2":
                return courseDtos.filter(item => item.visibilityEnd < currentDate);
            case "1":
                return courseDtos.filter(item => item.visibilityStart <= currentDate && item.visibilityEnd >= currentDate);
            default:
                return [];
        }
    };


    const columns = [
        {
            name: 'Titolo corso',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Luogo',
            selector: row => row.place,
            sortable: true,
        },
        {
            name: 'Categoria',
            selector: row => row.category,
            sortable: true,
        },
        {
            name: 'Visibile da',
            selector: row => row.start,
            sortable: true,
        },
        {
            name: 'Visibile fino a',
            selector: row => row.to,
            sortable: true,
        },
        {
            cell: () =><div className={'d-flex gap-2'}>
                <Link className={'btn btn-sm btn-outline-primary text-nowrap'}
                                                                   state={{from: (currentRow && currentRow.id)}} to={AppRoute.ADMIN_EDIT_COURSE}>Modifica</Link>
                <Link className={'btn btn-sm btn-primary text-nowrap'} to={'admin-detail-course'}
                      state={{from: (currentRow && currentRow.id)}}>Dettaglio</Link>,</div>,
            right: true,
        },
    ];


    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5 mb-5'}>
                                <h2 className={'title'}>Corsi</h2>
                            </div>
                        </Col>

                        <Col xs={'auto'}>
                            <div className={'mt-5'}>
                                <Link to={AppRoute.ADMIN_EDIT_COURSE} className={'btn btn-primary fw-bold mb-3 px-4'}>Nuovo
                                    corso</Link>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} sm={10} md={8} lg={4} xl={3}>
                            <Row>
                                <Col>
                                    <Form>
                                        <Form.Group className="mb-3 input-group" controlId="filter">
                                            <Form.Select className={'form-control'} value={courseFilter} onChange={event => setCourseFilter(event.target.value)}>
                                                <option value="0">Tutti i corsi</option>
                                                <option value="1">Corsi attuali</option>
                                                <option value="2">Corsi passati</option>
                                                <option value="3">Corsi futuri</option>
                                            </Form.Select>
                                            <Button
                                                variant={'primary'}
                                                type={'submit'}
                                                className={'fw-bold'}
                                            >Cerca</Button>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Col>
                <Col xs={12}>
				{currentPage !== null && (
                    <DataTable
                        columns={columns}
                        data={courseItems}
                        highlightOnHover
                        pagination
                        responsive
                        striped
						paginationDefaultPage={currentPage + 1}
                        onChangePage={handlePageChange}
                        paginationPerPage={25}
                        paginationRowsPerPageOptions={[25, 50, 100]}
                        onChangeRowsPerPage={pageLength => {
                            console.log("PageSize: " + pageLength)
                            setPageSize(pageLength)
                        }}
                        onRowMouseEnter={(row) => setCurrentRow(row)}
                    />
				)}
                </Col>
            </Row>
        </>

    );
}

export default AdminCourses;